import React from 'react';
import { Link } from 'react-router-dom';

const Authors = () => {
  return (
    <div className="container mt-5">
      <h1>For Authors</h1>
      <p className="lead">Information and resources for manuscript submission</p>

      <div className="row mt-4">
        <div className="col-md-6 mb-4">
          <div className="card h-100">
            <div className="card-body">
              <h3 className="card-title">Submission Guidelines</h3>
              <p className="card-text">
                Learn about our submission process, manuscript requirements, and formatting guidelines.
              </p>
              <Link to="/guide-for-authors" className="btn btn-primary">
                View Guidelines
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="card h-100">
            <div className="card-body">
              <h3 className="card-title">Submit Manuscript</h3>
              <p className="card-text">
                Ready to submit? Use our online submission system to submit your manuscript.
              </p>
              <Link to="/submit-paper" className="btn btn-success">
                Submit Now
              </Link>
            </div>
          </div>
        </div>

        {/* <div className="col-md-6 mb-4">
          <div className="card h-100">
            <div className="card-body">
              <h3 className="card-title">Manuscript Template</h3>
              <p className="card-text">
                Download our manuscript template to ensure proper formatting.
              </p>
              <Link to="/manuscript-template" className="btn btn-info">
                Get Template
              </Link>
            </div>
          </div>
        </div> */}


        <div className="col-md-6 mb-4">
          <div className="card h-100">
            <div className="card-body">
              <h3 className="card-title">Publication Ethics</h3>
              <p className="card-text">
                Review our publication ethics and responsibilities of authors.
              </p>
              <Link to="/ethics" className="btn btn-warning">
                View Ethics
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="card h-100">
            <div className="card-body">
              <h3 className="card-title">Review Process</h3>
              <p className="card-text">
                Understand our peer review process and timeline.
              </p>
              <Link to="/review-process" className="btn btn-secondary">
                Learn More
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="card h-100">
            <div className="card-body">
              <h3 className="card-title">Publication Fees</h3>
              <p className="card-text">
                Information about article processing charges and payment methods.
              </p>
              <Link to="/publication-charges" className="btn btn-danger">
                View Fees
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Authors;